/**
 * Connect Apps icon registry.
 *
 * Single source of truth mapping each icon slug to its React component and
 * alt text. Borderless brand-mark variants are used so the icons render
 * cleanly inside the dark Connect Apps pill.
 */

import type React from 'react';

import { GoogleDriveIconBorderless } from '../../../../constants/3p-product-configs/google/icon-borderless';
import { SalesforceIconBorderless } from '../../../../constants/3p-product-configs/salesforce/icon-borderless';
import { SlackIconBorderless } from '../../../../constants/3p-product-configs/slack/icon-borderless';

import { FigmaIconBorderless } from './icons/figma-borderless';
import { GithubIconBorderless } from './icons/github-borderless';
import type { ImgIconSlug } from './types';

type ConnectAppConfig = {
	Component: React.ComponentType;
	alt: string;
};

export const CONNECT_APPS_CONFIG: Record<ImgIconSlug, ConnectAppConfig> = {
	drive: { Component: GoogleDriveIconBorderless, alt: 'Google Drive' },
	salesforce: { Component: SalesforceIconBorderless, alt: 'Salesforce' },
	slack: { Component: SlackIconBorderless, alt: 'Slack' },
	github: { Component: GithubIconBorderless, alt: 'GitHub' },
	figma: { Component: FigmaIconBorderless, alt: 'Figma' },
};
